import {pageInfo, uploadUrl, addData, storageDetails, editData, settingToxinDetails, settingToxin, settingBatchDetails,settingBatchNo} from './../api';
import {Message} from 'element-ui';
import {plant,plantArea,storageTypeList,goodsCategory, plantToxin, getPlantGateSentry} from "../../../../api";

const interfaceLog = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    plantObj: [],
    plantAreaObj: [],
    exportObj: [],
    uploadUrl,
    storageTypeObj: null,
    addSubmitResp: null,
    storageDetailsObj: null,
    editSubmitResp: null,
    settingToxinDetailsObj: null,
    submitToxinResp: null,
    settingBatchDetailsResp: null,
    goodsCategoryObj: null,
    submitBatchResp: null,
    plantToxinObj: null,
    plantGateSentryObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    PLANT_AREA(state, data) {
      state.plantAreaObj = data;
    },
    STORAGE_TYPE(state, data) {
      state.storageTypeObj = data;
    },

    ADD_DATA(state, data){
      state.addSubmitResp = data;
    },
    EDIT_DATA(state, data){
      state.editSubmitResp = data;
    },

    STORAGE_UPDATE_INIT_DATA(state, data){
      state.storageDetailsObj = data.obj;
    },
    SETTING_TOXIN_UPDATE_INIT_DATA(state, data){
      state.settingToxinDetailsObj = data.obj;
    },
    SUBMIT_TOXIN(state, data){
      state.submitToxinResp = data;
    },
    SETTING_BATCH_DETAILS(state, data){
      state.settingBatchDetailsResp = data.obj;
    },
    GOODS_CATEGORY(state, data){
      state.goodsCategoryObj = data.obj;
    },

    SUBMIT_BATCH(state, data){
      state.submitBatchResp = data;
    },

    PLANT_TOXIN(state, data){
      state.plantToxinObj = data.obj;
    },
    PLANT_GATE_SENTRY(state, data){
      state.plantGateSentryObj = data.obj;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async plantArea({commit}, obj) {
      let resp = await plantArea(obj);
      commit('PLANT_AREA', resp);
    },
    async storageType({commit}, obj) {
      let resp = await storageTypeList(obj);
      commit('STORAGE_TYPE', resp);
    },
    //新增提交
    async addSubmit({ commit }, obj) {
      let resp = await addData(obj);
      commit('ADD_DATA', resp);
    },

    //编辑库位初始化
    async storageInitUpdate({ commit }, obj) {
      let resp = await storageDetails(obj);
      commit('STORAGE_UPDATE_INIT_DATA', resp);
    },
    //新增提交
    async editSubmit({ commit }, obj) {
      let resp = await editData(obj);
      commit('EDIT_DATA', resp);
    },

    //毒素初始化
    async settingToxinUpdate({ commit }, obj) {
      let resp = await settingToxinDetails(obj);
      commit('SETTING_TOXIN_UPDATE_INIT_DATA', resp);
    },

    //毒素设置提交
    async submitToxin({ commit }, obj) {
      let resp = await settingToxin(obj);
      commit('SUBMIT_TOXIN', resp);
    },

    //批次初始化
    async settingBatchDetails({ commit }, obj) {
      let resp = await settingBatchDetails(obj);
      commit('SETTING_BATCH_DETAILS', resp);
    },

    //货物种类
    async goodsCategory({ commit }, obj) {
      let resp = await goodsCategory(obj);
      commit('GOODS_CATEGORY', resp);
    },

    //批次设置提交
    async settingBatchNo({ commit }, obj) {
      let resp = await settingBatchNo(obj);
      commit('SUBMIT_BATCH', resp);
    },

    //查询毒素下拉框
    async plantToxin({ commit }, obj) {
      let resp = await plantToxin(obj);
      commit('PLANT_TOXIN', resp);
    },
    //门岗下拉框
    async getPlantGateSentry({ commit }, obj) {
      let resp = await getPlantGateSentry(obj);
      commit('PLANT_GATE_SENTRY', resp);
    },
  }
}
export default interfaceLog



// WEBPACK FOOTER //
// ./src/page/md/plantStorage/store/plantStorage.store.js